<template>
  <!-- star -->

  <div class="youjiaopage_wrap">

    <banner2 :bannerH="$t('contact.banner.title')" :style-height="styleHeight" :text-style="textStyle"
             :bannerP="$t('contact.banner.description')"
             :bannerImg="Img1"></banner2>

    <scroll-animate>
      <!-- 上部分 -->
      <div class="talk_top">
        <div class="talk_top_cont">
          <div class="talk_top_cont_l">
            <h1>{{ $t('contact.title') }}</h1>
            <p>contact us</p>
          </div>

          <el-descriptions :column="1">
            <!--          <el-descriptions-item label="公司电话"><a href="tel:02165101066">021-65101066</a></el-descriptions-item>-->
            <el-descriptions-item :label="$t('contact.companyPhone')"><a href="tel:18001820616">+86 180 0182 0616</a>
            </el-descriptions-item>
            <el-descriptions-item :label="$t('contact.salesDirector')"><a href="tel:13783169986">+86 137 8316 9986</a>
            </el-descriptions-item>
            <el-descriptions-item :label="$t('contact.contactPerson')"><a href="tel:17701729307">+86 177 0172 9307</a>
            </el-descriptions-item>
            <el-descriptions-item :label="$t('contact.companyEmail')"><a href="mailto:shanmai@shanmai-china.com">shanmai@shanmai-china.com</a>
            </el-descriptions-item>
          </el-descriptions>
          <!--        <div class="talk_top_cont_c">-->
          <!--          <div class="talk_top_cont_c_t">-->
          <!--            <div class="talk_top_cont_c_t_l">-->
          <!--              <p>公司电话: <a href="tel:02165101066">021-65101066</a></p>-->
          <!--            </div>-->
          <!--          </div>-->

          <!--          <div class="talk_top_cont_c_b">-->
          <!--            <div class="talk_top_cont_c_b_l">-->
          <!--              <p>联系人(李经理):<a href="tel:17701729307">177 0172 9307</a></p>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->
          <div class="talk_top_cont_r">
            <img src="@/assets/img/logo.png" alt=""/>
          </div>
        </div>
      </div>
      <!-- 下部分 -->
      <!--    <div class="addrMap">-->
      <!--      <h1>{{ $t('contact.headquarters') }}</h1>-->
      <!--      <div id="talk_bottom">-->
      <!--        <img src="@/assets/img/lianxi/addr.jpg" alt=""/>-->
      <!--      </div>-->
      <!--    </div>-->
    </scroll-animate>
  </div>
</template>

<script>
import banner2 from "../components/banner.vue";
import AMapLoader from '@amap/amap-jsapi-loader'
import ScrollAnimate from "../components/ScrollAnimate.vue";

export default {
  name: "contact",
  components: {
    ScrollAnimate,
    banner2,
  },
  data() {
    return {
      Img1: require("@/assets/img/lianxi/bannerImg.png"),
      styleHeight: {
        height: '300px',
      },
      textStyle: {
        width: '70%',
        height: '88%',
      },
    };
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.youjiaopage_wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
}

.talk_top {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

/* 联系我们 */
.talk_top_cont {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding-top: 50px;
  padding-bottom: 50px;
  background-color: white;
  margin-top: 50px;
  border-radius: 15px;
  //box-shadow: 0 6px 7px #a3a3a3;
  box-shadow: 0px 0px 70px rgba(157, 179, 208, 0.4);
}

.talk_top_cont_l {
  width: 235px;
  height: 134px;
  //margin-left: 50px;
  //margin-bottom: 50px;
  & > h1 {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #23337f;
    line-height: 45px;
  }

  p {
    width: 235px;
    height: 80px;
    font-size: 48px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #f6f6f6;
    line-height: 40px;
  }
}

.talk_top_cont_c {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  width: 487px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #444444;
  line-height: 25px;

  .talk_top_cont_c_t {
    margin: 2rem 2rem;

    .talk_top_cont_c_t_l {
      margin-right: 60px;
    }
  }

  .talk_top_cont_c_b {
    margin: 2rem 2rem;
  }
}


.talk_top_cont_r {
  width: 117px;
  margin-right: 5rem;

  @media screen and (max-width: 675px) {
    display: none;
  }

  img {
    width: 10rem;
  }
}

::v-deep .el-descriptions__body .el-descriptions__table {
  width: 20rem;
}

.addrMap {
  width: 100%;
  background-color: white;
  max-width: 1200px;
  margin: 5rem auto;
  padding: 1rem;
  border-radius: 2rem;

  h1 {
    text-align: center;
    margin-top: 2rem;
    color: $shen_green;
  }

  #talk_bottom {
    width: 100%;
    max-width: 900px;
    height: 45rem;
    margin: 5rem auto;
    border-radius: 1rem;

    img {
      width: 100%;
      border-radius: 15px;
    }
  }
}

</style>
